import Navbar from '../components/Navbar';
import './Panel.css';
import { useEffect, useState } from 'react';

function Panel() {
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const [ultimoAcceso, setUltimoAcceso] = useState('');

  useEffect(() => {
    const ahora = new Date();
    const fechaFormateada = ahora.toLocaleDateString('es-CL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    const horaFormateada = ahora.toLocaleTimeString('es-CL', {
      hour: '2-digit',
      minute: '2-digit'
    });
    setUltimoAcceso(`${fechaFormateada} a las ${horaFormateada}`);
  }, []);

  if (!usuario) {
    return <p>No has iniciado sesión</p>;
  }

  return (
    <>
      <Navbar nombre={usuario.nombre_completo} rol={usuario.rol} />
      <div className="panel-container">
        <div className="glass-card fadeIn slideUp">
          <h2>👋 Bienvenido, {usuario.nombre_completo}</h2>

          <div className="usuario-info">
            <p><strong>Nombre:</strong> {usuario.nombre_completo}</p>
            <p><strong>RUT Usuario:</strong> {usuario.id_usuario}</p>
            <p><strong>Empresa:</strong> {usuario.empresa}</p>
            <p><strong>RUT Empresa:</strong> {usuario.empresa_id}</p>
            <p><strong>Rol:</strong> {usuario.rol}</p>
            <p><strong>Último acceso:</strong> {ultimoAcceso}</p>
          </div>

          <div className="dashboard-grid">
            <div className="dashboard-card">
              <h3>Sensores activos</h3>
              <p className="dashboard-value">24</p>
            </div>

            <div className="dashboard-card alert">
              <h3>Alarmas activas</h3>
              <p className="dashboard-value">2</p>
            </div>

            <div className="dashboard-card warning">
              <h3>xxxx</h3>
              <p className="dashboard-value">3</p>
            </div>

            <div className="dashboard-card neutral">
              <h3>Pisciculturas monitoreadas</h3>
              <p className="dashboard-value">7</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Panel;
